<template>
  <v-dialog
    v-model="modal.active"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    width="500"
    height="300"
    transition="dialog-bottom-transition">
    <v-card v-if="modal.active">
      <v-card-title>
        <v-layout column>
          <span class="headline">{{ strings[idioma].compartilhar}}</span>
        </v-layout>
      </v-card-title>

      <v-card>
        <v-list>

          <v-list-tile
            class="list-restricoes">
            <v-list-tile-content>
              <v-layout
                align-center
                justify-space-around
                row
                style="width: 100%">

                <v-flex>
                  <!-- <v-checkbox
                    v-model="modal.pode_ler"
                    :label="strings[idioma].pode_ler"
                    readonly/> -->
                </v-flex>
                <v-flex>
                  <v-checkbox
                    v-model="modal.pode_editar"
                    :label="strings[idioma].pode_editar"
                    :readonly="modal.lockPermissoes"/>
                </v-flex>
                <v-flex>
                  <v-checkbox
                    v-model="modal.pode_compartilhar"
                    :label="strings[idioma].pode_compartilhar"
                    :readonly="modal.lockPermissoes"/>
                </v-flex>

              </v-layout>
              <template v-if="!modal.privado">
                <b>Link: (Ele já está copiado)</b>
                <textarea
                  readonly
                  style="width: 100%; height: 50px;">{{ modal.url }}</textarea>
              </template>
              <v-layout
                v-else
                align-center
                justify-space-around
                row
                style="width: 100%"
              >

                <v-flex xs2>
                  <label for="email" style="font-weight: 500;">
                    E-Mail:&nbsp;
                  </label>
                </v-flex>
                <v-flex xs8>
                  <v-text-field
                    id="email"
                    v-model="email_"
                    type="mail"/>
                </v-flex>
                <v-flex>
                  <v-btn
                    small
                    @click="addEmail(email_)">+</v-btn>
                </v-flex>
                <v-flex>
                  <v-btn
                    class="error"
                    small
                    icon
                    @click="removeEmail(email_)">-</v-btn>
                </v-flex>

              </v-layout>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            class="list-restricoes">
            <v-list-tile-content v-if="modal.emails.length > 0">
              <h4>E-Mails:</h4> <span style="width: 100%; overflow:auto;">
                <template v-for="email of modal.emails">
                  {{ email }}<v-btn
                    class="error"
                    small
                    icon
                    @click="removeEmail(email)">-</v-btn>
                </template>
              </span>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
      <v-card-actions>
        <v-btn
          v-if="modal.privado"
          @click="modal.privado = false; savePublico()">
          {{ strings[idioma].gerar_link_publico }}
        </v-btn>
        <v-checkbox
          v-if="!modal.privado"
          v-model="modal.privado"
          :label="strings[idioma].privado"/>

        <v-spacer/>
        <v-btn
          v-if="modal.emails.length > 0 || !modal.privado"
          :title="strings[idioma].salvar"
          color="primary"
          @click="save()"
        >
          <v-icon
            dark>mdi-share</v-icon>
        </v-btn>
        <v-btn
          color="error"
          @click="close"
        >
          <v-icon
            dark>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import { COMPARTILHAR_COM_TODAS_PERMISSOES } from '../../utils/types'
export default {
  props: {
    dieta: {
      type: Number,
      default: () => null
    },
    dieta_salva: {
      type: Object || Number,
      default: () => null
    },
    tipo: {
      type: String,
      default: () => 'formulacao-dieta'
    }
  },
  data: () => ({
    email_: '',
    comp: null,
    modal: {
      active: false,
      emails: [],
      privado: true,
      pode_ler: true,
      pode_editar: false,
      pode_compartilhar: false,
      msg: '',
      url: '',
      lockPermissoes: false
    },
    COMPARTILHAR_COM_TODAS_PERMISSOES: COMPARTILHAR_COM_TODAS_PERMISSOES
  }),
  computed: {
    ...mapState('app', ['step', 'user', 'trava_back', 'curr_version', 'strings', 'idioma'])
  },
  created () {
    if (!this.getAcessoModulo({ user: this.user, modulo: COMPARTILHAR_COM_TODAS_PERMISSOES })) {
      this.modal.pode_ler = 1
      this.modal.pode_editar = 1
      this.modal.pode_compartilhar = 1
      this.modal.lockPermissoes = true
    }
    let self = this
    function evAddEMail (evt) {
      evt = evt || window.event
      if (evt.keyCode === 13) {
        self.addEmail()
      }
    }
    this.email_ = ''
    this.modal.emails = []
    document.removeEventListener('keydown', evAddEMail)
    document.addEventListener('keydown', evAddEMail)
  },
  methods: {
    reset () {
      this.modal.emails = []
      if (this.modal.lockPermissoes) {
        this.modal.pode_ler = 1
        this.modal.pode_editar = 1
        this.modal.pode_compartilhar = 1
      } else {
        this.modal.pode_ler = 1
        this.modal.pode_editar = 0
        this.modal.pode_compartilhar = 0
      }
    },
    addEmail (email = null) {
      if (this.email_ === '') return
      let emails = this.email_.split(';')
      this.modal.emails = [...this.modal.emails, ...emails]
      this.modal.emails = Array.from(new Set(this.modal.emails))
      // this.modal.emails = Array.from(Set(this.modal.emails))
      this.email_ = ''
    },
    removeEmail (email) {
      console.log(email)
      this.modal.emails = this.modal.emails.filter(e => e !== email)
      this.email_ = ''
    },
    modalLink () {
      if (this.dieta_salva || this.dieta_salva === null || this.dieta_salva.id) return
      let url = window.location.origin + '/' + this.tipo + '?did=' + this.dieta_salva.id + '&assinatura=' + this.dieta_salva.assinatura

      let title = this.strings[this.idioma].msg_copia
      let msg = '<textarea readonly style="width: 100%; height: 200px;" value="' + url + '">' + url + '</textarea>'

      this.$store.commit('openOKModal', {
        title,
        msg
      })
      this.$copyText(url).then(function (e) {
        
      }, function (e) {
        
      })
    },
    savePublico () {
      this.axios.post('compartilhar', {
        emails: this.modal.emails,
        id_dieta: this.dieta_salva.id,
        permissoes: {
          pode_ler: this.modal.pode_ler,
          pode_editar: this.modal.pode_editar,
          pode_compartilhar: this.modal.pode_compartilhar,
          privado: this.modal.privado
        }
      }).then((r) => {
        let url = window.location.origin + '/' + this.tipo + '?did=' + this.dieta_salva.id + '&assinatura=' + this.dieta_salva.assinatura + '&compartilhamento=' + btoa(JSON.stringify(r.data.data))
        console.log(r.data.data)
        this.modal.url = url
        this.comp = r.data.data
        this.$copyText(url).then(function (e) {
          
        }, function (e) {
          
        })
      })
    },
    save () {
      // if (this.dieta_salva || this.dieta_salva === null || this.dieta_salva.id) return
      this.addEmail()

      this.axios.post('compartilhar', {
        emails: this.modal.emails,
        id_dieta: this.dieta_salva.id,
        permissoes: {
          id_compartilhamento: (this.comp !== null) ? this.comp.id : null,
          pode_ler: this.modal.pode_ler,
          pode_editar: this.modal.pode_editar,
          pode_compartilhar: this.modal.pode_compartilhar,
          privado: this.modal.privado
        }
      }).then(res => {
        // if (!this.modal.privado) return this.modalLink()
        let title = this.strings[this.idioma].compartilharSucesso
        let msg = ""
        this.$store.commit('openOKModal', {
          title,
          msg
        })
        this.reset()
        this.close()
      })
    },
    open () {
      // if (this.dieta_salva || this.dieta_salva === null || this.dieta_salva.id) return
      console.log(this.dieta_salva)
      this.modal.active = true
      let url = window.location.origin + '/formulacao-dieta?did=' + this.dieta_salva.id + '&assinatura=' + this.dieta_salva.assinatura
      let msg = '<textarea readonly style="width: 200px; height: 50px;" value="' + url + '">' + url + '</textarea>'
      this.modal.msg = msg
      this.modal.url = url
    },
    close () {
      this.reset()
      this.modal.active = false
    }
  }

}
</script>
